import { getExternalUserId, getIsTeacher } from '../base/local';
import { getTestTime } from '../base/question/querys';
import { ReducerRegistry, StateListenerRegistry } from '../base/redux';
import { getPolicy } from '../base/settings';
import { SET_ROOM_JOINED } from '../room';
import { setFocusTestId, setFocusUser, setTestNoticeMessage, toggleTestModal } from './action';
import { CLOSE_TEST_MODAL, SET_ANSWER_LIST, SET_FOCUS_TEST_ID, SET_FOCUS_USER, SET_NOT_SUBMIT_USER, SET_OMR_FREQUENCY, SET_PERSONAL_TIMER_STARTED, SET_TEST_TIME_UP, SET_QUESTION_LIST, SET_STATISCIS_LIST, SET_SUBMIT_LIST, SET_SURVEY_FREQUENCY, SET_SURVEY_SAVE, SET_TEST_BACKGROUND, SET_TEST_LIST, SET_TEST_TYPE, TOGGLE_FOLD_MODAL, TOGGLE_TEST_MODAL } from './actionTypes';
import { getFocusTestId, getIsEnterTestRoom, getIsTestOpenModal, getSubmitUserByTestIdAndMemberId, getTestItemByTestId, getTestList } from './functions';
import { disconnectWebsocket, setDisconnectWebsocketList } from './middleware';
const DEFAULT_STATE = {
    list: [],
    questionList: new Map(),
    answerList: [],
    statistics: new Map(),
    submitStatus: new Map(),
    backgroundUrl: '',
    isEnterRoom: false,
    isMockMode: false,
    openModal: false,
    foldModal: false,
    selectTestId: '',
    selectUser: undefined,
    selectUserSubmit: undefined,
    surveySave: new Map(),
    omrFrequency: new Map(),
    surveyFrequency: new Map(),
    testNoticeMessage: undefined,
    staticsOptions: {
        offset: 0,
        limit: 10,
    },
    testType: '',
    // 모의고사 개별 타이머가 '시작됨'으로 표시된 test_id 목록. 표시(red_time/풀이화면 타이머)가
    // 같은 redux 신호로 재렌더되도록 한다. 영속(새로고침/재입장)은 sessionStorage(mock_personal_timer:*)가 담당.
    personalStartedTimers: [],
    // 풀이시간 종료가 감지된 test_id 목록(무제출 포함). sessionStorage(mock_timeup:*)는 영속용이고,
    // 이 redux 값은 TestMain('테스트로 돌아가기' 숨김) 등 구독 컴포넌트의 리렌더를 담당한다.
    timeUpTests: [],
};
// sessionStorage(mock_personal_timer:*) 표식을 읽어 시작된 test_id 목록으로 복원.
// (재입장/새로고침 시 redux는 초기화되지만 sessionStorage는 유지되므로 여기서 hydrate)
const readStartedTimersFromSession = (list) => {
    const ids = [];
    (list || []).forEach((item) => {
        if (!item || !item.id)
            return;
        try {
            if (sessionStorage.getItem(`mock_personal_timer:${item.id}`) === '1') {
                ids.push(item.id);
            }
        }
        catch (e) { }
    });
    return ids;
};
function mergeData(firstData, secondData) {
    // Map을 사용해 중복 제거 및 두 번째 데이터 우선
    const mergedAnswersMap = new Map();
    // 첫 번째 데이터의 answers 추가
    firstData?.answers.forEach(answer => {
        mergedAnswersMap.set(answer.question_id, answer);
    });
    // 두 번째 데이터의 answers로 덮어쓰기
    secondData?.answers.forEach(answer => {
        mergedAnswersMap.set(answer.question_id, answer);
    });
    // 결과 배열로 변환
    const mergedAnswers = Array.from(mergedAnswersMap.values());
    const subjectItems = Array.from(new Set([...(firstData?.subject_items || []), ...(secondData?.subject_items || [])]));
    return {
        subject_items: subjectItems.length > 0 ? subjectItems : undefined,
        answers: mergedAnswers,
    };
}
ReducerRegistry.register('features/test', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_NOT_SUBMIT_USER:
            return {
                ...state,
                selectUserSubmit: action.submitted,
            };
        case SET_SURVEY_FREQUENCY:
            const updatedSurveyFrequency = new Map(state.surveyFrequency);
            // testId가 없는 경우, 새로운 항목으로 추가
            updatedSurveyFrequency.set(action.testId, action.frequency);
            return {
                ...state,
                surveyFrequency: updatedSurveyFrequency,
            };
        case SET_QUESTION_LIST:
            const updateQuestionList = new Map(state.questionList);
            // testId가 없는 경우, 새로운 항목으로 추가
            updateQuestionList.set(action.testId, action.questionList);
            return {
                ...state,
                questionList: updateQuestionList,
            };
        case SET_ANSWER_LIST:
            return {
                ...state,
                answerList: action.answerList,
            };
        case SET_STATISCIS_LIST:
            const updateStatisticsList = new Map(state.statistics);
            // testId가 없는 경우, 새로운 항목으로 추가
            updateStatisticsList.set(action.testId, action.statisticsList);
            return {
                ...state,
                statistics: updateStatisticsList,
            };
        case SET_SUBMIT_LIST:
            const submitStatusList = new Map(state.submitStatus);
            submitStatusList.set(action.testId, action.submitStatus);
            return {
                ...state,
                submitStatus: submitStatusList,
            };
        case SET_TEST_LIST:
            return {
                ...state,
                list: action.items,
                // 재입장/새로고침 시 sessionStorage 표식을 기준으로 시작된 타이머 목록 복원.
                personalStartedTimers: readStartedTimersFromSession(action.items),
            };
        case SET_PERSONAL_TIMER_STARTED:
            // sessionStorage 표식도 함께 세팅(새로고침/재입장 영속).
            try {
                sessionStorage.setItem(`mock_personal_timer:${action.testId}`, '1');
            }
            catch (e) { }
            if (state.personalStartedTimers.indexOf(action.testId) !== -1) {
                return state;
            }
            return {
                ...state,
                personalStartedTimers: [...state.personalStartedTimers, action.testId],
            };
        case SET_TEST_TIME_UP:
            if (state.timeUpTests.indexOf(action.testId) !== -1) {
                return state;
            }
            return {
                ...state,
                timeUpTests: [...state.timeUpTests, action.testId],
            };
        case SET_TEST_BACKGROUND:
            return {
                ...state,
                backgroundUrl: action.backgroundUrl !== undefined ? action.backgroundUrl : state.backgroundUrl,
            };
        case CLOSE_TEST_MODAL:
            return {
                ...state,
                openModal: false,
            };
        case TOGGLE_TEST_MODAL:
            const openModal = action.isModal !== undefined ? action.isModal : !state.openModal;
            return {
                ...state,
                openModal,
                foldModal: openModal === true ? false : state.foldModal,
                ...(action.isModal === false
                    ? {
                        selectTestId: '',
                        selectUser: undefined,
                        selectUserSubmit: undefined,
                    }
                    : {}),
            };
        case TOGGLE_FOLD_MODAL:
            return {
                ...state,
                foldModal: action.isModal !== undefined ? action.isModal : !state.foldModal,
            };
        case SET_FOCUS_TEST_ID:
            return {
                ...state,
                selectTestId: action.testId,
                staticsOptions: {
                    offset: 0,
                    limit: 10,
                },
            };
        case SET_FOCUS_USER:
            return {
                ...state,
                selectUser: action.user,
            };
        // case SET_SURVEY_FREQUENCY:
        // 	return {
        // 		...state,
        // 		surveyFrequency: action.frequency,
        // 	};
        case SET_OMR_FREQUENCY:
            const { testId, frequency } = action;
            const updatedOmrFrequency = new Map(state.omrFrequency); // 현재 omrFrequency 복사
            if (updatedOmrFrequency.has(testId)) {
                const existingFrequency = updatedOmrFrequency.get(testId);
                const serverData = mergeData(existingFrequency?.server, frequency?.server);
                const clientData = mergeData(existingFrequency?.client, frequency?.client);
                updatedOmrFrequency.set(testId, {
                    server: serverData,
                    client: {
                        subject_items: !serverData?.subject_items || serverData?.subject_items?.length <= 0 ? clientData.subject_items : serverData.subject_items,
                        answers: mergeData(existingFrequency.client, frequency?.client)?.answers,
                    }
                });
            }
            else {
                // testId가 없는 경우, 새로운 항목으로 추가
                updatedOmrFrequency.set(testId, {
                    server: {
                        subject_items: [],
                        answers: [],
                    },
                    client: { subject_items: [], answers: [] },
                    ...frequency,
                });
            }
            return {
                ...state,
                omrFrequency: updatedOmrFrequency, // 업데이트된 omrFrequency 저장
            };
        case SET_SURVEY_SAVE:
            const { testId: surveyTestId, surveySave } = action;
            const updatedSurveySave = new Map(state.surveySave); // 현재 omrFrequency 복사
            if (updatedSurveySave.has(surveyTestId)) {
                const existingFrequency = updatedSurveySave.get(surveyTestId);
                updatedSurveySave.set(surveyTestId, {
                    ...existingFrequency,
                    ...surveySave, // 기존의 frequency와 병합
                });
            }
            else {
                // testId가 없는 경우, 새로운 항목으로 추가
                updatedSurveySave.set(surveyTestId, {
                    server: {
                        subject_items: [],
                        answers: [],
                    },
                    client: { subject_items: [], answers: [] },
                    ...surveySave,
                });
            }
            return {
                ...state,
                surveySave: updatedSurveySave, // 업데이트된 omrFrequency 저장
            };
        // case SET_SURVEY_DATA:
        // 	return {
        // 		...state,
        // 		surveyData: action.data,
        // 	};
        case SET_TEST_TYPE:
            return {
                ...state,
                testType: action.testType,
            };
        case 'SET_IS_MOCK_MODE':
            return {
                ...state,
                isMockMode: action.isMockMode,
            };
        case SET_ROOM_JOINED:
            return {
                ...state,
                isEnterRoom: action.joined,
            };
        case 'SET_TEST_NOTICE_MESSAGE':
            return {
                ...state,
                testNoticeMessage: action.message,
            };
        case 'SET_SUBMIT_OPTION':
            return {
                ...state,
                staticsOptions: action.data,
            };
        case 'SET_IS_ENTER_ROOM': {
            return {
                ...state,
                isEnterRoom: action.isEnterRoom,
                ...(!action.isEnterRoom
                    ? {
                        openModal: false,
                        foldModal: false,
                        testNoticeMessage: undefined,
                        list: [],
                        questionList: new Map(),
                        answerList: [],
                        statistics: new Map(),
                        submitStatus: new Map(),
                        selectTestId: '',
                        selectUser: undefined,
                        selectUserSubmit: undefined,
                        surveyFrequency: {},
                    }
                    : {}),
            };
        }
    }
    return state;
});
const buildNotifyTimes = (endTime, minutes) => {
    const uniqMins = [...new Set(minutes)].filter(m => Number.isFinite(m) && m > 0);
    return uniqMins
        .map(m => ({
        time: endTime - m * 60 * 1000,
        message: `모의고사가 종료되기 ${m}분 전입니다!`,
    }))
        .sort((a, b) => a.time - b.time);
};
const endTimeByTestId = new Map();
const timersByTestId = new Map();
const clearTimers = (testId) => {
    const arr = timersByTestId.get(testId);
    if (arr && arr.length)
        arr.forEach(id => clearTimeout(id));
    timersByTestId.set(testId, []);
};
const scheduleNotificationsForTest = (store, testId) => {
    const endTime = endTimeByTestId.get(testId);
    if (!endTime)
        return;
    const policy = getPolicy(store.getState, 'notification_option');
    const mins = policy?.count_down_set ?? [];
    const defaultNotifyTimes = [
        { time: endTime - 3 * 60 * 1000, message: '모의고사가 종료되기 3분 전입니다!' },
        { time: endTime - 1 * 60 * 1000, message: '모의고사가 종료되기 1분 전입니다!' },
    ];
    const notifyTimes = Array.isArray(mins) && mins.length > 0
        ? buildNotifyTimes(endTime, mins)
        : defaultNotifyTimes;
    clearTimers(testId);
    const now = Date.now();
    const bucket = [];
    notifyTimes.forEach(({ time, message }) => {
        if (time <= now)
            return;
        const t = setTimeout(() => {
            store.dispatch(setTestNoticeMessage(message));
            const t2 = setTimeout(() => store.dispatch(setTestNoticeMessage('')), 2000);
            bucket.push(t2);
        }, time - now);
        bucket.push(t);
    });
    timersByTestId.set(testId, bucket);
};
const notifyBeforeTestEnd = async (store, test_id) => {
    try {
        const response = await getTestTime(test_id);
        if (response?.result?.remaining !== undefined) {
            const remainingTime = response.result.remaining; // 남은 시간 (초)
            const endTime = Date.now() + remainingTime * 1000; // 종료 시간
            endTimeByTestId.set(test_id, endTime);
            scheduleNotificationsForTest(store, test_id);
        }
    }
    catch (error) {
        console.error('Error fetching test time:', error);
    }
};
StateListenerRegistry.register(
// @ts-ignore
(state) => {
    const list = getTestList(state);
    return list.find((testItem) => testItem.status === 'open');
}, async (testItem, store) => {
    if (testItem && testItem.status === 'open') {
        notifyBeforeTestEnd(store, testItem.id);
        const openModal = getIsTestOpenModal(store.getState);
        if (!openModal)
            store.dispatch(toggleTestModal(true));
    }
}, {
    deepEquals: true,
});
StateListenerRegistry.register(
// @ts-ignore
(state) => {
    const arr = getPolicy(state, 'notification_option')?.count_down_set ?? [];
    return Array.isArray(arr) ? [...arr].sort((a, b) => a - b).join(',') : '';
}, (_normalized, store) => {
    const list = getTestList(store.getState);
    const open = list.filter((t) => t.status === 'open');
    open.forEach((t) => {
        if (endTimeByTestId.has(t.id)) {
            scheduleNotificationsForTest(store, t.id);
        }
    });
}, { deepEquals: true });
let intervalTest = null;
StateListenerRegistry.register(
// @ts-ignore
(state) => {
    if (getIsTeacher(state))
        return; // 선생님일 경우 아무것도 하지 않음
    if (!getIsEnterTestRoom(state))
        return; // 시험방에 들어가지 않은 경우 아무것도 하지 않음
    const list = getTestList(state);
    const openItems = list.filter((testItem) => testItem.status === 'open');
    let testList = [];
    openItems.forEach((testItem) => {
        const submitStatus = getSubmitUserByTestIdAndMemberId(state, testItem.id, getExternalUserId(state));
        // '제출 완료'가 확정된 테스트만 문자열(자동 포커스=결과 화면 오픈) 대상으로 삼는다.
        // getSubmitUserByTestIdAndMemberId 는 기록 미로딩/없음이면 빈 배열([])을 반환하는데,
        // []는 truthy라 과거 else 로 빠져 '아직 모름'까지 제출완료처럼 자동 포커스 → 갓 입장한
        // 미제출 학생을 시작 화면 건너뛰고 OMR로 밀어넣어(개별 타이머까지 조기 시작) 버렸다.
        // not_submitted === false(진짜 제출완료)일 때만 포커스하고, 그 외(미제출/미로딩)는 배열로.
        const submittedDone = submitStatus && !Array.isArray(submitStatus) && submitStatus.not_submitted === false;
        if (submittedDone) {
            testList = testItem.id;
        }
        else {
            testList.push(testItem.id);
        }
    });
    return testList;
}, async (testList, store) => {
    if (!testList)
        return;
    // 문자열인지 배열인지 체크
    if (typeof testList === 'string') {
        if (intervalTest)
            clearInterval(intervalTest);
        store.dispatch(setFocusTestId(testList));
        return;
    }
    if (intervalTest)
        clearInterval(intervalTest);
    setDisconnectWebsocketList(testList);
    intervalTest = setInterval(() => {
        disconnectWebsocket(undefined);
    }, 1000 * 60 * 1);
}, {
    deepEquals: true,
});
StateListenerRegistry.register(
// 객체 참조가 아닌 "id:status" 로 감시 — 과거엔 참조 비교라 백그라운드 재조회(setTestList)마다
// 같은 테스트여도 새 객체로 재발화해, 남의 제출 신호 한 번에 방 전원이
// SET_FOCUS_USER(REST+로딩) 캐스케이드를 타는 원인이 됐다.
// status 를 포함하는 이유: open→closed 전환(전체 타이머 종료/강제종료 시 서버 강제제출) 시
// 본인 제출상태를 재조회해야 '제출 완료' 화면 전환이 된다(id 만 보면 이 경우를 놓침).
// @ts-ignore
(state) => {
    if (!getFocusTestId(state))
        return undefined;
    const item = getTestItemByTestId(state);
    return item ? `${item.id}:${item.status}` : undefined;
}, async (testKey, store) => {
    if (!testKey)
        return; // 포커스 테스트가 없을 경우 아무것도 하지 않음
    if (getIsTeacher(store.getState))
        return; // 선생님일 경우 아무것도 하지 않음
    const member_id = getExternalUserId(store.getState);
    store.dispatch(setFocusUser(member_id, '-'));
});
